import React from 'react';

// Messenger speech bubble with a lightning bolt, drawn like the lucide icons (stroke,
// currentColor) so it takes className / colour from its parent the same way they do.
export default function MessengerIcon({ className = 'w-5 h-5', strokeWidth = 2 }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M12 3C6.9 3 3 6.8 3 11.4c0 2.6 1.3 4.9 3.3 6.4V21l3-1.7c.8.2 1.7.3 2.7.3 5.1 0 9-3.8 9-8.4S17.1 3 12 3z" />
      <path d="M7 13.5l3.5-4 2.5 2.5 4-3.5" />
    </svg>
  );
}
